export default __webpack_public_path__ + "static/media/T02.b43dad84.png";